import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('atlas_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      // Don't redirect for collaboration routes - guests don't need atlas_token
      const isCollabRoute = window.location.pathname.startsWith('/collab');
      const isPublicRoute = ['/login', '/register', '/'].includes(window.location.pathname);
      
      if (!isCollabRoute && !isPublicRoute) {
        localStorage.removeItem('atlas_token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
